import { Injectable } from '@angular/core';
 import { Observable } from 'rxjs/Observable';
 import 'rxjs/add/operator/map';
 import {
  IContactViewModel,
  IAddressModel,
  EncryptedContactViewModel
} from '../../../core/models/accountModel';
 import { DataService } from '../data.service';

@Injectable()
export class ProfileService {

 moduleUrl: string;
 EncryptedContactViewModel: EncryptedContactViewModel;
  constructor(private _dataService: DataService) {
    this.EncryptedContactViewModel = {
      id: ''
    };
  }


  getAddress(id: number): Observable<IContactViewModel> {
    this.moduleUrl = 'Contact/GetAddresses?ContactId=';
    return this._dataService.getSingle(this.moduleUrl, id);
  }


  addProfileInfo(iContactViewModel: IContactViewModel): Observable<IContactViewModel> {
    this.moduleUrl = 'Account';
    return this._dataService.add(this.moduleUrl, iContactViewModel);
  }

  updateProfileInfo(iContactViewModel: IContactViewModel): Observable<IContactViewModel> {
    this.moduleUrl = 'Contact';
    return this._dataService.UpdateWithoutId(this.moduleUrl, iContactViewModel);
  }

  addShippingAddress(iIContactViewModel: IContactViewModel): Observable<IContactViewModel> {
    this.moduleUrl = 'Contact/InsertProfileAddress';
    return this._dataService.add(this.moduleUrl, iIContactViewModel);
  }


  UpdateAddress(iShippingAddressesModel: IContactViewModel): Observable<IContactViewModel> {
    this.moduleUrl = 'Contact/UpdateAddressProfile';
    return this._dataService.UpdateWithoutId(this.moduleUrl, iShippingAddressesModel);
  }

  getProfilseDetails(id: any): Observable<IContactViewModel> {
    this.moduleUrl = 'Contact/';
    return this._dataService.getSingle( this.moduleUrl, id);
  }
  getProfileDetails(id: any): Observable<any> {
    this.EncryptedContactViewModel.id = id;
    this.moduleUrl = 'Contact/GetContactById';
    return this._dataService.add( this.moduleUrl, this.EncryptedContactViewModel);
  }
  deleteShippingAddess(id: any): Observable<IAddressModel> {
    this.moduleUrl = 'Contact/DeleteShippingAddress?addressId=' + id + '';
    return this._dataService.deletePost( this.moduleUrl, '');
  }
  GetCompanySourcingAdvisor(companyId: number): Observable<any> {
    this.moduleUrl = 'Contact/GetCompanySourcingAdvisor?CompanyId=' + companyId;
    return this._dataService.getAll( this.moduleUrl, '');
  }
  getUserList(visionUsersFilterViewModel: any): Observable<any> {
    this.moduleUrl = 'Account/GetVisionUserList';
    return this._dataService.add( this.moduleUrl, visionUsersFilterViewModel);
  }
}



// WEBPACK FOOTER //
// ./src/app/core/services/profile/profile.service.ts